<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref } from "vue"

const props = defineProps({
    initalValue: String,
});

const map = ref();

const activeFonds = ref(props.initalValue);
const selectFonds = (event) => {
    activeFonds.value = event.target.value;

    clearMarkers();
    addMarkersFromSelect();
    fitBounds();
};

const clearMarkers = () => {
    map.value._markers.forEach((marker) => marker.remove());
    map.value._markers = [];
};

const addMarkersFromSelect = (fonds) => {
    const aFonds = fonds ? fonds : activeFonds.value;
    let locations = null;
    try {
        locations = JSON.parse(
            document
                .getElementById("fonds-switch")
                .querySelector(`option[value="${aFonds}"]`)
                .getAttribute("data-locations")
        );
    } catch (e) {}

    if (!locations) {
        return;
    }

    locations.forEach((location) => {
        addMarker(location);
    });
};

const addMarker = (location) => {
    const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(location.content);

    const marker = new mapboxgl.Marker({ color: location.color })
        .setLngLat([location.lng, location.lat])
        .setPopup(popup)
        .addTo(map.value);
    marker.getElement().style.cursor = "pointer";

    map.value._markers.push(marker);
};

const fitBounds = () => {
    // const bounds = new mapboxgl.LngLatBounds();

    // map.value._markers.forEach((marker) => {
    //     bounds.extend(marker.getLngLat());
    // });

    map.value.fitBounds(
        [
            [10.17467, 47.270472],
            [8.388252, 55.047696],
        ],
        {
            padding: 50,
            duration: 800,
        }
    );
};

onMounted(() => {
    map.value = new mapboxgl.Map({
        style: "mapbox://styles/mapbox/light-v11",
        // zoom: 5,
        container: "locationsMap",
        // center: [9.93494, 51.388923],
    });

    map.value._markers = [];
    addMarkersFromSelect(document.getElementById("fonds-switch").value);

    fitBounds();

    window.addEventListener("resize", fitBounds);
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", fitBounds);
});
</script>

<template>
    <slot v-bind="{ selectFonds, activeFonds }" />
</template>
